function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var css = require('css-transition');

var toastyAudio = require('./partials/audio.js');

var toastyGuy = require('./partials/toasty-guy.js');

var SLIDE_IN_SPEED = 350;
var SLIDE_OUT_SPEED = 400;
var DELAY_UNTIL_SLIDE_OUT = 500;

module.exports = /*#__PURE__*/function () {
  /**
   * Set up a toasty guy bound to an element click
   * @param {string} el DOM selector
   */
  function Toasty(el) {
    _classCallCheck(this, Toasty);

    this.audio = this._createAudio();
    this.toastyGuy = this._createToastyGuy();
    this._inProgress = false;

    if (el) {
      this.element = document.querySelector(el);
      this._onClick = this._onClick.bind(this);
      this.element.addEventListener('click', this._onClick);
    }
  }
  /**
   * Create an audio element and add it to the DOM
   * @return {HTMLElement}
   * @private
   */


  _createClass(Toasty, [{
    key: "_createAudio",
    value: function _createAudio() {
      var a = document.createElement('div');
      a.innerHTML = toastyAudio;
      document.body.appendChild(a);
      return a.firstChild.nextSibling;
    }
    /**
     * Create a toasty guy image and add it to the DOM
     * @return {HTMLElement}
     * @private
     */

  }, {
    key: "_createToastyGuy",
    value: function _createToastyGuy() {
      var tg = document.createElement('div');
      tg.innerHTML = toastyGuy;
      document.body.appendChild(tg);
      return tg.firstChild.nextSibling;
    }
    /**
     * Handle click event and prevent default click action
     * @param {Event} e
     * @private
     */

  }, {
    key: "_onClick",
    value: function _onClick(e) {
      e.preventDefault();
      this.trigger();
    }
    /**
    * Play the sound and handle the lifecycle of the toasty animation
    * @return {Promise}
    */

  }, {
    key: "trigger",
    value: function trigger() {
      var _this = this;

      if (this._inProgress) {
        return new Promise(function (resolve, reject) {
          return reject();
        });
      }

      this._inProgress = true;
      this.playAudio();
      return this.slideIn().then(function () {
        return _this._delayUntilSlideOut();
      }).then(function () {
        return _this.slideOut();
      }).then(function () {
        return _this._inProgress = false;
      });
    }
    /**
     * Play the toasty audio file
     */

  }, {
    key: "playAudio",
    value: function playAudio() {
      this.audio.play();
    }
    /**
     * Animate toasty guy into the visible viewport
     * @return {Promise}
     */

  }, {
    key: "slideIn",
    value: function slideIn() {
      var _this2 = this;

      this.toastyGuy.style.display = 'block';
      /**
       * Since toasty guy appears from off screen, this makes sure
       * horizontal scrollbar doesn't show up while he's poppin' in
       */

      this._origOverflowX = document.body.style.overflowX;
      document.body.style.overflowX = 'hidden';
      /**
       * Slide that piece of shit in
       */

      return new Promise(function (resolve) {
        css(_this2.toastyGuy, {
          right: 0
        }, SLIDE_IN_SPEED, function () {
          return resolve();
        });
      });
    }
    /**
     * Give a promise that resolves after the slide out delay
     * @return {Promise}
     * @private
     */

  }, {
    key: "_delayUntilSlideOut",
    value: function _delayUntilSlideOut() {
      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve();
        }, DELAY_UNTIL_SLIDE_OUT);
      });
    }
    /**
     * Slide toasty guy back and reset the body overflow-x CSS prop to its original value
     * @return {Promise}
     */

  }, {
    key: "slideOut",
    value: function slideOut() {
      var _this3 = this;

      return new Promise(function (resolve) {
        css(_this3.toastyGuy, {
          right: "-".concat(_this3.toastyGuy.offsetWidth, "px")
        }, SLIDE_OUT_SPEED, function () {
          _this3.toastyGuy.style.display = 'none';
          document.body.style.overflowX = _this3._origOverflowX;
          resolve();
        });
      });
    }
    /**
     * Remove all created DOM nodes and detach event handlers
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.toastyGuy) {
        var tgContainer = this.toastyGuy.parentNode;
        tgContainer.parentNode.removeChild(tgContainer);
        this.toastyGuy = null;
      }

      if (this.audio) {
        var audioContainer = this.audio.parentNode;
        audioContainer.parentNode.removeChild(audioContainer);
        this.audio = null;
      }

      if (this.element) {
        this.element.removeEventListener('click', this._onClick);
      }

      this._inProgress = false;
    }
  }]);

  return Toasty;
}();